import {Button, CircularProgress} from '@mui/material';
import {ExamModule, ModuleTopic} from '@cp/model';
import {env} from '../../../config/env';
import {useCreateQuestionGenerationJob} from '../../../hooks/jobs/useCreateQuestionGenerationJob';

export interface ModuleViewGenerateButtonProps {
  examModule: ExamModule;
  topic: ModuleTopic;
  difficulty?: number;
  label?: string;
}

export default function ModuleViewGenerateButton({
  examModule,
  topic,
  difficulty,
  label,
}: ModuleViewGenerateButtonProps) {
  const {createQuestionGenerationJob, loading: loadingState} = useCreateQuestionGenerationJob();

  const handleGenerateQuestions = async (topicName: string, questionDifficulty?: number) => {
    try {
      await createQuestionGenerationJob(examModule.id, [topicName], questionDifficulty); // Default count of 5
    } catch (error) {
      console.error('Error creating question generation job:', error);
    }
  };

  const buttonColor = env.difficulty[difficulty || env.difficultyAnyIndex].color;
  const buttonTitle = `Generate ${env.difficulty[difficulty || env.difficultyAnyIndex].label} questions`;
  const buttonText = label || difficulty;

  return (
    <Button
      key={difficulty || 'all'}
      variant="contained"
      size="small"
      disabled={loadingState}
      onClick={() => {
        handleGenerateQuestions(topic.topic, difficulty);
      }}
      sx={{
        bgcolor: buttonColor,
        '&:hover': {bgcolor: buttonColor, opacity: 0.8},
        '&:disabled': {bgcolor: '#ccc', color: '#666'},
        fontSize: '0.7rem',
        px: 1,
        py: 0.5,
        minWidth: 'auto',
        color: 'white',
        fontWeight: 500,
        position: 'relative',
        minHeight: '32px',
      }}
      title={buttonTitle}
    >
      {loadingState ? (
        <CircularProgress
          size={16}
          sx={{
            color: 'white',
            position: 'absolute',
          }}
        />
      ) : (
        buttonText
      )}
    </Button>
  );
}
